import {
  trackSourceRecommendationAppliedSpec,
  trackSourceRecommendationCustomisedSpec,
  trackSourceRecommendationDismissedSpec,
  trackSourceRecommendationShownSpec,
  type SourceRecommendationApplied,
  type SourceRecommendationCustomised,
  type SourceRecommendationDismissed,
  type SourceRecommendationShown,
} from '@snowtype/snowplow';

import { TrackingEventName } from '@/models/analytics/eventTypes';

import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const sourceRecommendationEvents: SnowplowEventMap = {
  [TrackingEventName.SourceRecommendationShown]: (props) =>
    trackSourceRecommendationShownSpec(props as SourceRecommendationShown),
  [TrackingEventName.SourceRecommendationDismissed]: (props) =>
    trackSourceRecommendationDismissedSpec(props as SourceRecommendationDismissed),
  [TrackingEventName.SourceRecommendationApplied]: (props) =>
    trackSourceRecommendationAppliedSpec(props as SourceRecommendationApplied),
  [TrackingEventName.SourceRecommendationCustomised]: (props) =>
    trackSourceRecommendationCustomisedSpec(props as SourceRecommendationCustomised),
};
